import { motion } from 'framer-motion';
import { BigButton } from '../../components/BigButton';
import { AuthModalContentProps } from './logic';
import animations from '../../helpers/animations';
import { useTranslation } from 'react-i18next';

export default function CheckEmailContent({
    setCurrentColumn,
}: AuthModalContentProps) {
    const { t } = useTranslation();

    return (
        <motion.form {...animations.fadeInOut(0.05)}>
            <div className="title-wrapper">
                <h2 className="title">
                    {t('check_email_confirmation.title_wrapper.title')}
                </h2>
                <p className="description">
                    {t('check_email_confirmation.title_wrapper.description')}
                </p>
            </div>
            <svg
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="airplane-icon"
            >
                <mask
                    id="mask0_2187_5925"
                    maskUnits="userSpaceOnUse"
                    x="-7"
                    y="0"
                    width="87"
                    height="86"
                >
                    <path
                        d="M-6.06055 0.799072H79.0475V85.9071H-6.06055V0.799072Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_2187_5925)">
                    <path
                        d="M69.4905 27.8748L2.79297 41.2424L15.7385 51.7958L18.2713 67.2741L26.5733 60.9421L35.4382 68.5405L69.4905 27.8748Z"
                        fill="#FFD900"
                    />
                    <path
                        d="M68.6118 28.2969L15.7812 51.823L18.2584 67.3025L19.7495 57.0021L26.464 60.9715L19.9606 55.8061"
                        fill="#525252"
                    />
                </g>
            </svg>
            <BigButton
                bgColor={'primary'}
                color={'primary'}
                onClick={() => setCurrentColumn('login')}
            >
                {t('check_email_confirmation.big_button.submit_text')}
            </BigButton>
        </motion.form>
    );
}
